import { Element, Node, Path, Transforms } from 'slate';

import * as serializer from 'basic-editor-value-serializer';

import { normalizeLayoutChildren } from './children';
import { withLayoutDelete } from './delete';
import { withLayoutPaste } from './paste';

const types = serializer.types;
const layoutUtilities = serializer.utilities.node.layout;

function isSame(first, second) {
  return JSON.stringify(first) === JSON.stringify(second);
}

function countLayoutAncestors(editor, path) {

  let count = 0;

  for (const [ancestor] of Node.ancestors(editor, path)) {
    if (ancestor.type === types.LAYOUT) {
      count++;
    }
  }

  return count;

}

function setProperties(editor, node, path, properties) {
  Transforms.setNodes(editor, { properties: { ...node.properties, ...properties } }, { at: path });
}

function normalizeSettings(editor, node, path) {

  const stored = (node.properties || {}).layout;
  const sanitized = layoutUtilities.sanitizeSettings(stored);

  if (isSame(stored, sanitized) === true) {
    return false;
  }

  setProperties(editor, node, path, { layout: sanitized });
  return true;

}

function tryAddTrailingParagraph(editor, path) {

  if (path.length !== 1 || Node.has(editor, Path.next(path)) === true) {
    return false;
  }

  Transforms.insertNodes(editor, serializer.utilities.node.paragraph.buildNode(), { at: Path.next(path) });
  return true;

}

function normalizeLayout(editor, node, path) {

  if (countLayoutAncestors(editor, path) >= layoutUtilities.MAX_DEPTH) {
    Transforms.unwrapNodes(editor, { at: path });
    return true;
  }

  if (normalizeSettings(editor, node, path) === true) {
    return true;
  }

  if (normalizeLayoutChildren(editor, node, path) === true) {
    return true;
  }

  return tryAddTrailingParagraph(editor, path);

}

function normalizeItemSettings(editor, node, path) {

  const properties = node.properties || {};

  if (typeof properties.layoutItem === 'undefined' || path.length === 0) {
    return false;
  }

  const parent = Node.parent(editor, path);

  if (parent.type !== types.LAYOUT) {
    const withoutItem = { ...properties };
    delete withoutItem.layoutItem;
    Transforms.setNodes(editor, { properties: withoutItem }, { at: path });
    return true;
  }

  const sanitized = layoutUtilities.sanitizeItemSettings(properties.layoutItem);

  if (isSame(properties.layoutItem, sanitized) === true) {
    return false;
  }

  setProperties(editor, node, path, { layoutItem: sanitized });
  return true;

}

function withLayout(editor) {

  const normalizeNode = editor.normalizeNode;

  editor.normalizeNode = function normalizeLayoutNode(entry) {

    const node = entry[0];
    const path = entry[1];

    if (Element.isElement(node) === true && normalizeItemSettings(editor, node, path) === true) {
      return;
    }

    if (node.type === types.LAYOUT && normalizeLayout(editor, node, path) === true) {
      return;
    }

    normalizeNode(entry);

  };

  return withLayoutPaste(withLayoutDelete(editor));

}

export default withLayout;
